import type { DateKey } from '@features/quote/utils/dateKey';

// Sorted before serialising: `Object.keys` order on a numeric record is
// insertion-independent, so an identical set could otherwise miss the cache.
export function scheduleOverridesKey(dateOverrides: Record<number, DateKey> | undefined): string {
    if (!dateOverrides) {
        return '';
    }
    return Object.keys(dateOverrides)
        .map(Number)
        .sort((a, b) => a - b)
        .map((row) => `${row}:${dateOverrides[row]}`)
        .join(',');
}
